export const GET_LIST_RANKS_WATCHER =
  "app/WidgetAnalysisSegmentTeam/GET_LIST_RANKS_WATCHER"
export const GET_LIST_RANKS_SUCCESS =
  "app/WidgetAnalysisSegmentTeam/GET_LIST_RANKS_SUCCESS"
export const GET_LIST_RANKS_FAILED =
  "app/WidgetAnalysisSegmentTeam/GET_LIST_RANKS_FAILED"
